export const MARKDOWN_EDITOR_LAYOUT_KEY = 'jarvis-markdown-editor-layout';

export type MarkdownEditorLayoutMode = 'edit' | 'split' | 'preview';

export function readMarkdownEditorLayoutPreference(): MarkdownEditorLayoutMode {
  if (typeof localStorage === 'undefined') return 'edit';
  const stored = localStorage.getItem(MARKDOWN_EDITOR_LAYOUT_KEY);
  return stored === 'split' || stored === 'preview' ? stored : 'edit';
}

export function writeMarkdownEditorLayoutPreference(mode: MarkdownEditorLayoutMode): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(MARKDOWN_EDITOR_LAYOUT_KEY, mode);
}
